import React, { Component } from "react";

import ArrowUp from "./src/select-up-img2.png";
import Blank from "./src/select-up-img-blank.png";

export default class ResultPc extends Component {
  onSpriteText = (value) => {
    var splited = value.split(" ");

    var rows = [];
    var txt = "";
    for (var i = 0; i < splited.length; i++) {
      if (i < 1) {
        rows.push(
          <div key={Math.random().toString(36).substr(2, 9)}>{splited[i]}</div>
        );
      } else {
        txt += splited[i];
      }
    }

    rows.push(<div key={Math.random().toString(36).substr(2, 9)}>{txt}</div>);

    return <div>{rows}</div>;
  };

  render() {
    const { ...data } = { ...this.props.result };
    return (
      <div className="result-pc-main">
        <div>
          <img
            onClick={
              this.props.current.id !== data.id
                ? null
                : this.props.info
                ? null
                : () => this.props.onInfo()
            }
            src={
              this.props.current.id !== data.id
                ? Blank
                : this.props.info
                ? Blank
                : ArrowUp
            }
            alt=""
            className="result-pc-arrow-up"
          />
        </div>
        <div
          onClick={() => this.props.onSelect(data)}
          className="result-pc-button-container"
        >
          <img
            className={
              this.props.current.id === data.id
                ? "result-pc-image-select"
                : "result-pc-image-unselect"
            }
            src={data.iconlink}
            alt="icon"
          />

          <div className="result-pc-text">{data.name}</div>
        </div>
      </div>
    );
  }
}
